import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  corpoFormulario: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 40,
  },
  tableContainer: {
    borderRadius: theme.shape.borderRadius || '8px',
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    backgroundColor: theme.palette.background?.paper || '#ffffff',
    '& table': {
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    '& tbody tr:last-child td': {
      borderBottom: theme.shape.borderRadius,
    },
    '& tbody tr:last-child td:first-child': {
      borderBottomLeftRadius: theme.shape.borderRadius || '8px',
    },
    '& tbody tr:last-child td:last-child': {
      borderBottomRightRadius: theme.shape.borderRadius || '8px',
    },
  },
  tableHeader: {
    backgroundColor: theme.palette.background?.default || '#f4f6f8',
  },
  tableRow: {
    backgroundColor: theme.palette.background?.paper || '#ffffff',
    width: '100%',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action?.hover || '#f9f9f9',
    },
  },
  dadoEspelho: {
    fontSize: '13px',
  },
  grupoEspelho: {
    padding: theme.spacing(2),
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  typography: {
    paddingTop: theme.spacing(2),
  },
  divider: {
    margin: '40px 0 24px 0',
    height: '1px',
    backgroundColor: theme.palette.divider,
  },
  navigationContainer: {
    padding: '8px 4px',
  },
  containerCampos: {
    padding: theme.spacing(1),
  },
  fieldGroup: {
    padding: `${theme.spacing(1)}px 0`,
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  labelInput: {
    fontSize: '14px',
  },
  divTitulo: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  cardMobile: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius || '4px',
    backgroundColor: theme.palette.background?.paper || '#ffffff',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: theme.shadows?.[1] || '0px 2px 1px -1px rgba(0,0,0,0.2)',
  },
  cabecalhoCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  conteudoCard: {
    fontSize: '13px',
    marginBottom: theme.spacing(1.5),
  },
  labelCard: {
    fontWeight: 'bold',
    color: theme.palette.text?.secondary || '#546e7a',
  },
  acoesCard: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
}))
